export const ADD_ITEM_CART = 'ADD_ITEM_CART'
export const DEL_ITEM_CART = 'DEL_ITEM_CART'
export const ADD_EMPRESA = 'ADD_EMPRESA'
export const ADD_CATALOGO = 'ADD_CATALOGO'
export const ADD_ITENS = 'ADD_ITENS'
export const ADD_MARCAS = 'ADD_MARCAS'
export const ADD_TOTAL = 'ADD_TOTAL'
export const ADD_ENDERECO = 'ADD_ENDERECO'
export const ADD_DADOSCOMPRA = 'ADD_DADOSCOMPRA'
export const ADD_STATUSCATALOGO = 'ADD_STATUSCATALOGO'
export const ADD_FPAGAMENTO = 'ADD_FPAGAMENTO'
export const ADD_IDPEDIDO = 'ADD_IDPEDIDO'
export const ADD_GRUPOS = 'ADD_GRUPOS'
export const ADD_SUBGRUPOS = 'ADD_SUBGRUPOS'
export const ADD_SKUS = 'ADD_SKUS'
export const ADD_CADASTRO_PRODUTO = 'ADD_CADASTRO_PRODUTO'
export const ADD_CART = 'ADD_CART'
export const SAVE_LOCAL_CART = 'SAVE_LOCAL_CART'
export const DELETE_LOCAL_CART = 'DELETE_LOCAL_CART'